module.exports = __webpack_public_path__ + "img/np.28d74d78.jpg";